<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.0783 14.2896L20.1007 13.7751C20.1136 13.4808 19.908 13.2062 19.6154 13.1718C19.4835 13.1553 19.3501 13.1864 19.2392 13.2595C19.1282 13.3325 19.0469 13.4428 19.01 13.5704L18.5567 15.1407L15.2192 11.8034L18.5716 8.45098C19.6226 7.40003 20.227 5.9837 20.2585 4.49772L20.2794 3.52428L19.3059 3.545C17.8199 3.57664 16.4035 4.18106 15.3525 5.23208L12.0002 8.5842L8.648 5.23208C7.59701 4.18114 6.1807 3.57676 4.69475 3.54513L3.72111 3.52428L3.74184 4.49772C3.77346 5.98371 4.37789 7.40004 5.42892 8.45098L8.78129 11.8034L5.44383 15.1408L4.99046 13.5706C4.95352 13.443 4.87227 13.3327 4.76131 13.2596C4.65035 13.1866 4.51695 13.1555 4.38511 13.1719C4.0925 13.2063 3.887 13.4813 3.89975 13.7753L3.92215 14.2898C3.97348 15.465 4.37781 16.5974 5.0824 17.5394L3.60355 19.0183C3.99024 19.4212 4.40528 19.796 4.84548 20.1397L6.26395 18.7213C7.20604 19.4259 8.33864 19.8302 9.51397 19.8814L10.0284 19.9038C10.3226 19.9166 10.5976 19.711 10.6318 19.4184C10.6482 19.2866 10.6171 19.1532 10.544 19.0422C10.471 18.9312 10.3607 18.8499 10.233 18.813L8.66285 18.3596L12.0002 15.0223L15.3376 18.3596L13.7675 18.813C13.6398 18.8499 13.5295 18.9312 13.4564 19.0422C13.3834 19.1532 13.3523 19.2866 13.3687 19.4184C13.4031 19.711 13.6781 19.9166 13.9722 19.9038L14.4865 19.8814C15.6619 19.8301 16.7944 19.4259 17.7366 18.7213L19.1549 20.1396C19.5951 19.7959 20.0102 19.4212 20.397 19.0183L18.9181 17.5394C19.6227 16.5974 20.0271 15.4649 20.0783 14.2896Z"
            fill="url(#paint0_linear_5156_515)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5156_515"
                x1="12.0001"
                y1="20.1397"
                x2="12.0001"
                y2="3.52428"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#3F414B" />
                <stop offset="1" stop-color="#6F727E" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
